export const styles = theme => ({
  title: {
    fontSize: 24
  },
  highlight: {
    color: theme.palette.red.color,
  },
  list: {
    paddingLeft: 16,
    color: theme.palette.lightgrey.color,
    fontWeight: 400,
    marginBottom: 0
  },
  listItem: {
    padding: '0px 0px 15px 15px',
  },
  emphasize: {
    fontWeight: 400,
  },
})
